import { render, staticRenderFns } from "./addDormRoomBed.vue?vue&type=template&id=ff817246&"
import script from "./addDormRoomBed.vue?vue&type=script&lang=js&"
export * from "./addDormRoomBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports